// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Divider-module__ui-Divider--ZTMgT {
  height: 1px;
  background: #E4DFD8;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Divider/Divider.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".ui-Divider {\n  height: 1px;\n  background: #E4DFD8;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Divider": `Divider-module__ui-Divider--ZTMgT`
};
export default ___CSS_LOADER_EXPORT___;
